import { observer } from "mobx-react";
import {
  isAdminRoute,
  isAnonymousRoute,
  isBoardMemberRoute,
  isShareholderRoute,
  isStoriesRoute,
  isSuperadminRoute,
  isUserRoute,
  MatchedDCRoute,
} from "./routes";
import UserRoutes from "./UserRoutes";
import { AnonymousRoutesView } from "./AnonymousRoutesView";
import { lazy } from "react";
const BoardMemberViewRoutes = lazy(() => import("./BoardMemberViewRoutes"));
const ShareholderViewRoutes = lazy(() => import("./ShareholderViewRoutes"));
const AdminRoutes = lazy(() => import("./AdminRoutes"));
const AdminApp = lazy(() => import("../AdminApp/AdminApp"));
const Stories = lazy(() => import("../stories"));

export const RoutesView = observer(({ route }: { route?: MatchedDCRoute }) => {
  const render = () => {
    switch (true) {
      case isBoardMemberRoute(route):
        return <BoardMemberViewRoutes />;
      case isShareholderRoute(route):
        return <ShareholderViewRoutes />;
      case isAdminRoute(route):
        return <AdminRoutes />;
      case isSuperadminRoute(route):
        return <AdminApp />;
      case isStoriesRoute(route):
        return <Stories />;
      case isUserRoute(route):
        return <UserRoutes />;
      case isAnonymousRoute(route):
        return <AnonymousRoutesView />;
      default:
        return null;
    }
  };

  return <>{render()}</>;
});
